import React, { Component } from 'react';

export default class TestComponent extends Component {
  render() {
    var x = 10;
    var y = x[3].b;
    return <div>Demo</div>;
  }
}
